export default "__VITE_ASSET__a5744ce6__"